import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { observer } from 'mobx-react';
import cls from 'classnames';
import { SystemAlertType } from '@/alert/entities/SystemAlert';
import { useAlertStore } from '@/alert/stores/AlertStore';
import Button from '@/common/components/Button/Button';
import Icon from '@/common/components/Icon/Icon';
import RichText from '@/common/components/RichText/RichText';
import { formatMarkdown } from '@/common/helpers/formatMarkdown';
import { useUserStore } from '@/user/stores/UserStore';
import styles from './SystemAlertRow.module.less';
const ICON_CLASSNAME_MAP = {
    [SystemAlertType.Error]: styles.iconError,
    [SystemAlertType.Info]: styles.iconInfo,
    [SystemAlertType.Warning]: styles.iconWarning,
};
function SystemAlertRow(props) {
    const { alert } = props;
    const { closeAlert, closeAlertLocally } = useAlertStore();
    const { isAuthorized } = useUserStore();
    function renderAlertIcon() {
        switch (alert.priority) {
            case SystemAlertType.Error:
                return _jsx(Icon, { name: "block" });
            case SystemAlertType.Warning:
                return _jsx(Icon, { name: "warning" });
            case SystemAlertType.Info:
            default:
                return null;
        }
    }
    const onCloseHandler = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        return isAuthorized ? closeAlert(alert.id) : closeAlertLocally(alert.id);
    }, [alert.id]);
    return (_jsxs("div", { className: styles.alert, children: [_jsx("span", { className: cls(styles.alertIcon, ICON_CLASSNAME_MAP[alert.priority]), children: renderAlertIcon() }), _jsx(RichText, { value: formatMarkdown(alert.content), config: { ADD_ATTR: ['target'] } }), _jsx(Button, { className: styles.alertClose, size: "m", "aria-label": "Close Alert", color: "transparent", onClick: onCloseHandler, withIcon: true, children: _jsx(Icon, { name: "close" }) })] }));
}
export default observer(SystemAlertRow);
